export const ROUTES = Object.freeze({
  ACTIVITY: '/activity',
  ADMIN: {
    EDIT: '/admins/:id',
  },
  ADMINS: '/admins',
  CAPABILITIES: {
    CAPABILITIES: '/capabilities/capabilities',
    CAPABILITY: '/capabilities/capabilities/:name',
    FEATURE_GROUP: '/capabilities/feature-groups/:name',
    FEATURE_GROUPS: '/capabilities/feature-groups',
    PLAN: '/capabilities/plans/:name',
    PLANS: '/capabilities/plans',
    ROLE: '/capabilities/roles/:name',
    ROLES: '/capabilities/roles',
    ROOT: '/capabilities',
  },
  CLIENT: {
    AMB: '/clients/:id/amb',
    BILLING: '/clients/:id/billing',
    CUSTOM_DOMAIN: '/clients/:id/custom-domain',
    FEATURE_GROUPS: '/clients/:id/feature-groups',
    GENERAL: '/clients/:id/general',
    INFO: '/clients/:id/info',
    KEYWORDS: '/clients/:id/keywords',
    MEMBERS_COMPLIANCE: '/clients/:id/members-compliance',
    MESSAGES: '/clients/:id/messages',
    NUMBER_IMPORT: '/clients/:id/number-import',
    NUMBER_PROVISIONING: '/clients/:id/number-provisioning',
    OVERVIEW: '/clients/:id',
    SIGN_UP: '/clients/:id/sign-up',
    TCR: '/clients/:id/tcr',
    TEAM: '/clients/:id/team',
  },
  CLIENTS: '/clients',
  MEMBER: '/member',
  SSO_CONFIG: '/sso-configs/:id',
  SSO_CONFIGS: '/sso-configs',
  SSO_CONFIG_NEW: '/sso-configs/new',
} as const)
